import { cn } from '@/true-fsd/shared/utils/css'
import { isWebKit } from '../../utils/browserDetection'

/**
 * Пропсы для иконки шрифта
 */
export interface FontIconProps {
    /**
     * Дополнительные CSS классы
     */
    className?: string
    /**
     * Цвет иконки (для WebKit fallback)
     */
    color?: string
}

/**
 * WebKit-версия иконки шрифта
 * Использует fill вместо stroke для лучшей совместимости с Safari
 * Увеличенный размер для лучшей видимости
 */
function FontIconWebKit({ className, color }: FontIconProps) {
    // Дефолтный цвет для WebKit
    const fillColor = color || '#94a6af'

    return (
        <svg
            width="30"
            height="26"
            viewBox="-1 -1 25 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            aria-hidden="true"
            preserveAspectRatio="xMidYMid meet"
        >
            {/* Буква T - вертикальная линия */}
            <rect x="10.5" y="5" width="1.5" height="9" rx="0.75" fill={fillColor} />
            {/* Буква T - горизонтальная линия */}
            <rect x="6.5" y="5" width="9" height="1.5" rx="0.75" fill={fillColor} />
            
            {/* Внешняя рамка - верхняя часть */}
            <path
                d="M4.25 1.5H18.25C19.0456 1.5 19.75 2.20442 19.75 3V8H18.25V3H4.25V8H2.75V3C2.75 2.20442 3.45442 1.5 4.25 1.5Z"
                fill={fillColor}
            />
            {/* Внешняя рамка - нижняя часть */}
            <path
                d="M4.25 18H18.25C19.0456 18 19.75 17.2956 19.75 16.5V11.5H18.25V16.5H4.25V11.5H2.75V16.5C2.75 17.2956 3.45442 18 4.25 18Z"
                fill={fillColor}
            />
            
            {/* Правый коннектор */}
            <rect x="18.5" y="8" width="3.5" height="1.5" fill={fillColor} />
            <rect x="18.5" y="10" width="3.5" height="1.5" fill={fillColor} />
            <rect x="20.5" y="8" width="1.5" height="3.5" fill={fillColor} />
            
            {/* Левый коннектор */}
            <rect x="0.5" y="8" width="3.5" height="1.5" fill={fillColor} />
            <rect x="0.5" y="10" width="3.5" height="1.5" fill={fillColor} />
            <rect x="0.5" y="8" width="1.5" height="3.5" fill={fillColor} />
        </svg>
    )
}

/**
 * Стандартная версия иконки шрифта (с stroke)
 */
function FontIconStandard({ className }: FontIconProps) {
    return (
        <svg
            viewBox="0 0 23 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            aria-hidden="true"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M11.25 5.75V13.75M11.25 5.75H7.25M11.25 5.75H15.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.25 11.25V16.75C20.25 17.2804 20.0393 17.7891 19.6642 18.1642C19.2891 18.5393 18.7804 18.75 18.25 18.75H4.25C3.71957 18.75 3.21086 18.5393 2.83579 18.1642C2.46071 17.7891 2.25 17.2804 2.25 16.75V11.25M20.25 8.25V2.75C20.25 2.21957 20.0393 1.71086 19.6642 1.33579C19.2891 0.960714 18.7804 0.75 18.25 0.75H4.25C3.71957 0.75 3.21086 0.960714 2.83579 1.33579C2.46071 1.71086 2.25 2.21957 2.25 2.75V8.25M18.75 11.25V8.25H21.75V11.25H18.75ZM0.75 11.25V8.25H3.75V11.25H0.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    )
}

/**
 * Иконка выбора шрифта
 * Автоматически выбирает версию в зависимости от браузера
 */
export function FontIcon({ className, color }: FontIconProps) {
    const useWebKit = isWebKit()

    if (useWebKit) {
        return <FontIconWebKit className={className} color={color} />
    }

    return <FontIconStandard className={className} />
}

